import { fetcher } from '@commenda/utils';
import { TUpdateBillingQuoteLineTerms } from './types';

export const updateBillingQuoteLineTerms = async (
  quoteId: string,
  lineId: string,
  terms: TUpdateBillingQuoteLineTerms
) =>
  fetcher(`commenda-billing/quotes/${quoteId}/lines/${lineId}/terms`, {
    method: 'PATCH',
    body: terms,
  });
